import React, { useEffect } from 'react';
import { translations } from 'src/constants/translations';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import {
  IComplexProperty,
  IMarketplacePlacementProperty,
  RoundingMethods,
  roundingMethodsOptions,
  roundingMethodsOptionsMap,
  ThousandsSeparator,
  thousandsSeparatorOptions,
  thousandsSeparatorOptionsMap,
} from 'src/components/profileComponents/Marketplace/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import { IMarketplaceTilesRange } from 'src/typings/marketplace';
import Box from '@mui/material/Box';
import {
  useStyles,
} from './styles';

interface Props {
  item: IMarketplaceTilesRange;
  lang: string;
  complexPropertyOptions: IDevelopmentSpecificationPropChange<IComplexProperty>[]
  onChange: (item: IMarketplaceTilesRange) => void,
}
export const TileMinMaxRange: React.FC<Props> = ({
  item, lang, complexPropertyOptions, onChange,
}) => {
  const styles = useStyles();
  const mainStyles = mainUseStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(item.isActive);

  useEffect(() => {
    setRocketState(item.isActive);
  }, [item]);

  const rocketChange = (state: boolean) => {
    onChange({ ...item, isActive: state });
    setRocketState(state);
  };

  return (
    <Box style={{ backgroundColor: 'white' }}>
      <GroupWrapper
        name="Min-Max Range"
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => setCollapseState(state)}
          />
        )}
      >
        { collapseState === GroupWrapperCollapseState.OPEN && (
          <div className={styles.tileLocationRangeWrapper}>
            <div className={styles.shortWrapper}>
              <BoxFormTextField
                label={translations.fromNaming}
                name="fromPrefix"
                defaultValue={item.fromPrefix?.[lang]}
                onChange={(event) => {
                  onChange(updateTranslatedField(item, 'fromPrefix', lang, event.target.value));
                }}
              />
            </div>
            <BoxFormAutocomplete
              label={translations.chooseProperty}
              name="property"
              defaultValue={
                item.property ? {
                  label: item.property?.translates?.[lang] || item.property?.systemName,
                  value: item.property,
                } : undefined
              }
              onChange={(event: IDevelopmentSpecificationPropChange<IMarketplacePlacementProperty>) => {
                onChange({ ...item, property: event.value });
              }}
              options={complexPropertyOptions}
            />
            <div className={styles.shortWrapper}>
              <BoxFormTextField
                label={translations.toNaming}
                name="toPrefix"
                defaultValue={item.toPrefix?.[lang]}
                onChange={(event) => {
                  onChange(updateTranslatedField(item, 'toPrefix', lang, event.target.value));
                }}
              />
            </div>
            <div className={styles.shortWrapper}>
              <BoxFormTextField
                label={translations.uom}
                name="uom"
                defaultValue={item?.uomText?.[lang]}
                onChange={(event) => {
                  onChange(updateTranslatedField(item, 'uomText', lang, event.target.value));
                }}
              />
            </div>
            <div className={styles.shortWrapper}>
              <BoxFormAutocomplete
                label={translations.roundingMethod}
                name="roundingMethod"
                defaultValue={{
                  label: roundingMethodsOptionsMap[item.numberTransformationConfig.precision],
                  value: item.numberTransformationConfig.precision,
                }}
                onChange={(event: IDevelopmentSpecificationPropChange<RoundingMethods>) => {
                  onChange({
                    ...item,
                    numberTransformationConfig: { ...item.numberTransformationConfig, precision: event.value },
                  });
                }}
                options={roundingMethodsOptions}
              />
            </div>
            <div className={styles.shortWrapper}>
              <BoxFormAutocomplete
                label={translations.thousandsSeparator}
                name="thousandsSeparator"
                defaultValue={{
                  label: thousandsSeparatorOptionsMap[item.numberTransformationConfig.thousandsSeparator],
                  value: item.numberTransformationConfig.thousandsSeparator,
                }}
                onChange={(event: IDevelopmentSpecificationPropChange<ThousandsSeparator>) => {
                  onChange({
                    ...item,
                    numberTransformationConfig: { ...item.numberTransformationConfig, thousandsSeparator: event.value },
                  });
                }}
                options={thousandsSeparatorOptions}
              />
            </div>
          </div>
        ) }
      </GroupWrapper>
    </Box>
  );
};
